import AdjustmentDetails from "./AdjustmentDetails";
import ManualAdjustment from "./ManualAdjustment";
import NetImpact from "./NetImpact";
import NoAdjDetect from "./NoAdjDetect";
import { useSelector } from "react-redux";
import { getDeepViewValuesEntry } from "../../deepViewFieldMap";
import { areAmountsEqual } from "../../deepViewNumbers";
import ManualAdjustmentNeutral from "./ManualAdjustmentNeutral";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
  /** Label of the column the user clicked, e.g. "Total Income (USD)" */
  columnLabel?: string;
}

const StageFive = ({ columnKey, columnLabel }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );

  const valuesEntry = getDeepViewValuesEntry(deepViewData, columnKey);
  const beforeAdj = valuesEntry?.fmt_before_adj_usd;
  const afterAdj = valuesEntry?.fmt_after_adj_usd;
  const isAdjustable = beforeAdj !== null && beforeAdj !== undefined;
  const hasAdjustments = isAdjustable && !areAmountsEqual(beforeAdj, afterAdj);

  return (
    <>
      {hasAdjustments ? (
        <>
          <ManualAdjustment columnKey={columnKey} />
          <NetImpact columnKey={columnKey} columnLabel={columnLabel} />
          <AdjustmentDetails columnKey={columnKey} columnLabel={columnLabel} />
        </>
      ) : (
        <>
          <NoAdjDetect />
          <ManualAdjustmentNeutral columnKey={columnKey} />
        </>
      )}
    </>
  );
};

export default StageFive;
